import React from 'react'

import { ExampleComponent } from 'minimal-switch'
import 'minimal-switch/dist/index.css'

const App = () => {
  return <ExampleComponent text="Create React Library Example 😄" />
}

export default App
